export default __webpack_public_path__ + "fonts/vue_logo.465e3810a5f527918c3291ce908440db.png";